import { render, staticRenderFns } from "./ProjectsPanelTemplateNavItem.vue?vue&type=template&id=52e279e0&"
import script from "./ProjectsPanelTemplateNavItem.vue?vue&type=script&lang=js&"
export * from "./ProjectsPanelTemplateNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports